import * as React from "react";
import Menu from "@mui/material/Menu";
import Tooltip from "@mui/material/Tooltip";
import styled from "@emotion/styled";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import DateRangePicker from '@mui/lab/DateRangePicker';
import { DateRange } from "react-date-range";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import moment from "moment";
import { TextField, Stack, InputLabel, Select, MenuItem } from "@mui/material";
import { getSupportCategories } from "../../Controllers/AppManagement/helpSupport";
import { useEffect } from "react";
let isChanged = false;
export default function Filter({ filterState, setFilterState, callFunction }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [state, setState] = React.useState({
    /* Component State */ supportCategory: [],
    selectedData: {},
    index: -1,
  });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStatusChange = (event) => {
    setFilterState({ ...filterState, fStatus: event.target.value });
    isChanged = true;
  };

  const handleApply = () => {
    if (isChanged) {
      callFunction(1);
      setAnchorEl(null);
    } else {
      alert("Please select filter");
    }
  };

  const handleClear = () => {
    setFilterState({});
    callFunction(1, true);
    setAnchorEl(null);
    isChanged = false;
  };

  useEffect(() => {
    fetchCategories();
    isChanged = false;
    // eslint-disable-next-line
  }, []);

  const fetchCategories = async () => {
    /* Get Categories and sub categories */
    const res = await getSupportCategories();
    if (res.data.status === 200) {
      setState({ ...state, ...res.data.data });
    }
  };

  const handleSelectCategory = (cat) => {
    state.supportCategory.some((object) => {
      if (object.category === cat) {
        setFilterState({ ...filterState, fCategory: cat });
        setState({ ...state, selectedData: object });
        isChanged = true;
        return true;
      } else {
        return false;
      }
    });
  };

  return (
    <>
      <Tooltip title="Filter">
        <FilterAltIcon
          className="pointer"
          style={{
            margin: "0 1rem 0 1rem",
          }}
          onClick={handleClick}
        />
      </Tooltip>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <Container>
          <FormControl>
            <strong>By Status</strong>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              defaultValue={filterState?.fStatus ? filterState?.fStatus : ""}
              onChange={handleStatusChange}
            >
              <FormControlLabel
                value="Unread"
                control={<Radio />}
                label="Unread"
              />
              <FormControlLabel
                value="Resolved"
                control={<Radio />}
                label="Resolved"
              />
              <FormControlLabel
                value="Unresolved"
                control={<Radio />}
                label="Unresolved"
              />
            </RadioGroup>
          </FormControl>
          <Divider />
          <br />

          {/*FROM AND TO DATE PICKER*/}
          <div className="date_div">
            <strong>By Date</strong>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <TextField
                id="Date From"
                type={"date"}
                fullWidth
                defaultValue={
                  filterState.fStartDate
                    ? moment(filterState.fStartDate).format("YYYY-MM-DD")
                    : ""
                }
                // label="Start date"
                onChange={(e) => {
                  setFilterState({
                    ...filterState,
                    fStartDate: moment(e.target.value).format("YYYY-MM-DD"),
                  });
                  isChanged = true;
                }}
              />

              <TextField
                id="Date To"
                type={"date"}
                fullWidth
                // label="End date"
                defaultValue={
                  filterState.fEndDate
                    ? moment(filterState.fEndDate).format("YYYY-MM-DD")
                    : ""
                }
                onChange={(e) => {
                  setFilterState({
                    ...filterState,
                    fEndDate: moment(e.target.value).format("YYYY-MM-DD"),
                  });
                  isChanged = true;
                }}
              />
            </Stack>
          </div>
          <Divider />
          <br />

          <div className="country_select_div">
            <strong>By Category</strong>
            <FormControl sx={{ width: "100%", color: "green" }}>
              <InputLabel id="category">Category</InputLabel>
              <Select
                className="category"
                id="category"
                label="Category"
                defaultValue={filterState?.fCategory}
                onChange={(e) => {
                  handleSelectCategory(e.target.value);
                }}
              >
                {state.supportCategory.map((data) => (
                  <MenuItem value={data.category}>{data.category}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <Divider />
          <br />

          {state.selectedData.category && filterState?.fCategory && (
            <div className="country_select_div">
              <strong>By Sub-category</strong>
              <FormControl sx={{ width: "100%", color: "green" }}>
                <InputLabel id="category">Sub-category</InputLabel>
                <Select
                  className="Sub-category"
                  id="Sub-category"
                  label="Sub-category"
                  defaultValue={filterState?.fSubCategory}
                  onChange={(e) => {
                    setFilterState({
                      ...filterState,
                      fSubCategory: e.target.value,
                    });
                    isChanged = true;
                  }}
                >
                  {state.selectedData.subCategory.map((data) => (
                    <MenuItem value={data.name}>{data.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Divider />
              <br />
            </div>
          )}

          <Actions>
            <Button
              variant="contained"
              size="small"
              style={{ textTransform: "unset" }}
              onClick={handleApply}
            >
              Apply filter
            </Button>
            <Button
              variant="outlined"
              size="small"
              style={{ textTransform: "unset" }}
              onClick={handleClear}
            >
              Clear filter
            </Button>
          </Actions>
        </Container>
      </Menu>
    </>
  );
}

const Container = styled("div")`
  padding: 1rem;
  .my-2 {
    margin-top: 1rem;
  }
  & > .short_by {
    display: flex;
    flex-direction: column;
    & > div {
      display: flex;
      column-gap: 1rem;
    }
  }
  & > .country_select_div {
    margin-bottom: 0.5rem;
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
  }
  & > .date_div {
    margin-bottom: 0.5rem;
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
  }
`;

const Actions = styled("div")`
  margin-top: 1rem;
  display: flex;
  column-gap: 1rem;
`;
